module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_8-68f4cc04.jpg";